const doc = [({"en":({"js":({"live_streaming_feeds":({"broadcaster":({"settings":({"audio_input":"Audio input", "video_input":"Video input"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;